module.exports = __webpack_public_path__ + "static/img/logo1.75d8e2a3.svg";